import React from 'react';
import { TouchableOpacity, Text, StyleSheet, TouchableOpacityProps, ActivityIndicator, View, Image } from 'react-native';

interface GoogleButtonProps extends TouchableOpacityProps {
  title: string;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
}

function GoogleLogo() {
  return (
    <Image
      source={require('../assets/images/google-logo.png')}
      style={{ width: 24, height: 24 }}
      resizeMode="contain"
    />
  );
}

export default function GoogleButton({ title, onPress, disabled = false, loading = false, style, ...props }: GoogleButtonProps) {
  return (
    <TouchableOpacity
      style={[styles.button, { opacity: disabled ? 0.6 : 1 }, style]}
      onPress={disabled || loading ? undefined : onPress}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <ActivityIndicator color="#151515" size="small" />
      ) : (
        <>
          <View style={styles.icon}>
            <GoogleLogo />
          </View>
          <Text style={styles.buttonText}>{title}</Text>
        </>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: '#DAD8CF',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    paddingVertical: 16,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    height: 56,
    width: '100%',
  },
  icon: {
    width: 24,
    height: 24,
  },
  buttonText: {
    fontSize: 14,
    fontFamily: 'Inter_500Medium',
    lineHeight: 20,
    textAlign: 'center',
    fontWeight: '500',
    color: '#151515',
  },
});
